import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Chip } from "@mui/material";
import { darken, styled, useTheme } from "@mui/material/styles";
const UserMessage = styled(Box)(({ theme }) => ({
    alignSelf: "flex-end",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: "20px",
    padding: theme.spacing(1),
    maxWidth: "70%",
    marginBottom: theme.spacing(1),
    fontSize: "0.8em",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
}));
const UserContent = ({ content }) => {
    var _a;
    const contentTextEls = content.filter((e) => e.type === "text");
    const contentTextEl = contentTextEls[0] || null;
    const contentSystemEl = contentTextEls[1] || null;
    const contentImageEl = content.find((e) => e.type === "image_url");
    const contentText = (contentTextEl === null || contentTextEl === void 0 ? void 0 : contentTextEl.text) || "";
    const contentImage = ((_a = contentImageEl === null || contentImageEl === void 0 ? void 0 : contentImageEl.image_url) === null || _a === void 0 ? void 0 : _a.url) || undefined;
    let contentSystemName = undefined;
    if (contentSystemEl && contentSystemEl.text) {
        try {
            const contentSystem = JSON.parse(contentSystemEl.text);
            contentSystemName = contentSystem.name;
        }
        catch (_b) { }
    }
    const theme = useTheme();
    const chipColor = theme.palette.getContrastText("#4d4d4d");
    return (_jsxs(_Fragment, { children: [_jsx(UserMessage, { children: contentText }), contentImage && (_jsx(Box, Object.assign({ sx: { display: "flex", justifyContent: "flex-end" } }, { children: _jsx("img", { style: { width: "20em", height: "auto" }, alt: "", src: contentImage }) }))), contentSystemName && (_jsx(Box, Object.assign({ sx: { display: "flex", justifyContent: "flex-end" } }, { children: _jsx(Chip, { sx: {
                        mr: "5px",
                        height: "27px",
                        color: chipColor,
                        backgroundColor: chipColor && darken(chipColor, 0.73),
                    }, label: contentSystemName.length > 40
                        ? `${contentSystemName.slice(0, 40)}...`
                        : contentSystemName }) })))] }));
};
export default UserContent;
